import logoUrl from '../assets/logo.png';

interface LogoProps {
  size?: number;
  /** Render the wordmark ("Skematiq" text) next to the mark */
  wordmark?: boolean;
}

/**
 * Skematiq brand mark — the app icon (blue schematic "S" monogram on graphite),
 * imported so it renders identically in dev and in the packaged app.
 */
export function Logo({ size = 26, wordmark = true }: LogoProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <img
        src={logoUrl}
        width={size}
        height={size}
        alt="Skematiq"
        style={{
          flexShrink: 0,
          borderRadius: 'var(--radius)',
          display: 'block',
        }}
      />
      {wordmark && (
        <div
          style={{
            fontWeight: 700,
            fontSize: 15,
            color: 'var(--text)',
            letterSpacing: '-0.2px',
            lineHeight: 1,
          }}
        >
          Skematiq
        </div>
      )}
    </div>
  );
}
